import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useCourseSurveys = () => {
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url, time } = hooks.useApi()
    const { id: userId, isStudent } = hooks.useCurrentUser()

    const { data, isLoading } = useQuery(
        [cacheKeys.COURSE_SURVEYS, userId],
        () => api.get(url(endpoints.userCourseSurveys, {userId})),
        {
            staleTime: time.HOUR,
            enabled: Boolean(userId)
        }
    )

    const courseSurveys = data || []

    return {
        courseSurveys,
        isLoadingCourseSurveys: isLoading,
    }
}

export default useCourseSurveys
